export enum CheckoutSck {
  DirectAccess = 'NEW_CLUB_SALES_PAGE',
  SmartAds = 'HOTMART_CLUB_TRENDRECOMMENDERSP',
  ShowCaseAccess = 'HOTMART_MEM_CA'
}

export enum TransactionStatus {
  Refused = 'REFUSED',
  Received = 'RECEIVED',
  Cancelled = 'CANCELLED',
  Authorised = 'AUTHORISED',
  UnderAnalysis = 'UNDER_ANALYSIS'
}

export type TransactionData = {
  hotpayReference: string
  status: TransactionStatus
}

export const CheckoutWrapperId = 'sales-page-checkout-wrapper'
